<template>
  <div>
    <headerSection :mainMenu="mainMenu"></headerSection>

    <!-- Running Text Section -->
    <RunningText
      text="เว็บตรง ไม่ล็อคยูส ฝาก-ถอน โอนไว 5 วินาที ไม่มีขั้นต่ำ ไม่ติดเทิร์น ไม่จำกัดการถอน คืนยอดเสีย 5% เเนะนำเพื่อนรับเพิ่ม 3% แอดมินบริการ 24 ชั่วโมง"
      extraClasses="home-style"
    />

    <!-- Main Layout Container -->
    <div class="main-layout">
      <!-- Desktop Layout -->
      <div class="desktop-layout desktop-only">
        <!-- Left Sidebar -->
        <LeftSidebar
          :leftMenuItems="leftMenuItems"
          :hoveredIndex="hoveredLeftIndex"
          :user="user"
          @menu-enter="onLeftMenuEnter"
          @menu-leave="onLeftMenuLeave"
        />

        <!-- Main Content Area -->
        <div class="main-content">
          <!-- Cashback Cover Section -->
          <!-- <div class="x-cover x-index-event-container" style="padding-top: 0px;">
            <img src="../assets/images/covers/promotion-cover.webp" class="-bg" alt="คืนยอดเล่น ทุกวัน ทุกเกม ทุกการเดิมพัน">
            <img src="../assets/images/covers/promotion-cover-mobile.webp" class="-bg -mobile" alt="คืนยอดเล่น ทุกวัน ทุกเกม ทุกการเดิมพัน">

            <div class="container-fluid">
              <div class="row -contents-wrapper">
                <div class="col-12 col-md-6 -left-content"></div>
                <div class="col-12 col-md-6 -right-content bg-mobile">
                  <div data-slickable="{&quot;fade&quot;:true,&quot;arrows&quot;:false,&quot;autoplay&quot;:true,&quot;infinite&quot;:true,&quot;pauseOnHover&quot;:false,&quot;adaptiveHeight&quot;:true,&quot;slidesToShow&quot;:1,&quot;autoplaySpeed&quot;:5000}" data-animatable="fadeInUp" data-delay="200" class="slick-initialized slick-slider animated fadeInUp">
                    <div class="slick-list draggable" style="height: 58px;">
                      <div class="slick-track" style="opacity: 1; width: 4495px; top: 5px; display: flex; justify-content: flex-end; float: right;">
                        <div class="slick-slide slick-current slick-active resize bg-mobile2" data-slick-index="0" aria-hidden="false" style="position: relative; left: 0px; top: 0px; z-index: 999; opacity: 1;">
                          &nbsp;
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

          <!-- Main Menu Bar -->
          <MainMenuBar
            :mainMenuItems="mainMenuItems"
            :hoveredIndex="hoveredMainIndex"
            :user="user"
            @menu-enter="onMainMenuEnter"
            @menu-leave="onMainMenuLeave"
          />

          <!-- Cashback Content -->
          <div class="content-wrapper">
            <!-- Cashback Section -->
            <div class="x-cashback-container">
              <div class="container">
                <div class="row -cashback-row-wrapper">
                  <div class="col-sm-12 col-lg-12 col-12 recommend_section">
                    <fieldset class="form-group text-center mb-0 px-1">
                      <div class="row mt-2 mb-0 mb-4 justify-content-md-center">
                        <div class="col-sm-12 col-lg-12 col-12">
                          <h2 class="text-center mb-3" style="font-weight: 500;color:#fff;">คืนยอดเล่น</h2>
                          <img src="https://firebasestorage.googleapis.com/v0/b/phenixs789.firebasestorage.app/o/images%2F-Mz_m97zG-sNYbk4wxDC.png?alt=media&token=1653d422-016d-4754-a874-efb612a89873" class="-cover-img img-fluid">
                        </div>
                      </div>
                    </fieldset>

                    <div class="text-title text-center" style="font-family: Kanit;">ยอดเล่น</div>
                    <div class="row no-gutters">
                      <div class="col-6">
                        <div class="card-report text-center">
                          <p class="mb-1" style="font-family: Kanit;">ฝาก</p>
                          <p class="mb-0">{{ numberWithCommas(this.cashback.deposit )}}</p>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="card-report text-center">
                          <p class="mb-1" style="font-family: Kanit;">ถอน</p>
                          <p class="mb-0">{{ numberWithCommas(this.cashback.withdraw )}}</p>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="card-report text-center">
                          <p class="mb-1" style="font-family: Kanit;">รายได้ทั้งหมด</p>
                          <p class="mb-0">{{ numberWithCommas(this.cashback.total )}}</p>
                        </div>
                      </div>
                      <div class="col-12 text-center" style="padding-top:22px;">
                        <a href="javascript:void(0)" @click="moveCashbackToWallet()" class="text-white js-account-approve-aware btn" :style="checkStyle()" data-toggle="modal">
                          <div style="font-size: 14px;font-family: Kanit,Helvetica Neue,Helvetica,Arial,sans-serif;">โอนเงินเข้ากระเป๋าหลัก</div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-lg-12 col-12 recommend_section">
                    <div v-html="nl2br(detail)" style="text-align: center;padding:30px;font-size: 16px;font-family: Kanit;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile Layout -->
      <div class="mobile-layout mobile-only">
        <!-- Mobile Cashback Cover Section -->
        <div class="x-cover x-index-event-container mobile-cover" style="padding-top: 63px;">
          <!-- <img src="../assets/images/covers/promotion-cover.webp" class="-bg" alt="คืนยอดเล่น ทุกวัน ทุกเกม ทุกการเดิมพัน">
          <img src="../assets/images/covers/promotion-cover-mobile.webp" class="-bg -mobile" alt="คืนยอดเล่น ทุกวัน ทุกเกม ทุกการเดิมพัน"> -->

          <div class="x-cover x-index-event-container" style="padding-top: 17px;">
            <div class="container-fluid">
              <div class="row -contents-wrapper">
                <div class="col-12 col-md-6 -left-content">&nbsp;</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Mobile Main Menu -->
        <MobileMainMenu :mainMenuItems="mainMenuItems" :user="user" />

        <!-- Mobile With Sidebar Layout -->
        <div class="mobile-with-sidebar">
          <!-- Mobile Left Sidebar -->
          <MobileLeftSidebar
            :leftMenuItems="leftMenuItems"
            :hoveredIndex="hoveredLeftIndex"
            :user="user"
            @menu-enter="onLeftMenuEnter"
            @menu-leave="onLeftMenuLeave"
          />

          <!-- Mobile Content Area -->
          <div class="mobile-content">
            <!-- Mobile Cashback Content -->
            <div class="mobile-content-wrapper">
              <!-- Mobile Cashback Section -->
              <div class="x-cashback-container">
                <div class="container">
                  <div class="row -cashback-row-wrapper">
                    <div class="col-sm-12 col-lg-12 col-12 recommend_section">
                      <fieldset class="form-group text-center mb-0 px-1">
                        <div class="row mt-2 mb-0 mb-4 justify-content-md-center">
                          <div class="col-sm-12 col-lg-12 col-12">
                            <h2 class="text-center mb-3" style="font-weight: 500;color:#fff;">คืนยอดเล่น</h2>
                            <img src="https://firebasestorage.googleapis.com/v0/b/phenixs789.firebasestorage.app/o/images%2F-Mz_m97zG-sNYbk4wxDC.png?alt=media&token=1653d422-016d-4754-a874-efb612a89873" class="-cover-img img-fluid">
                          </div>
                        </div>
                      </fieldset>

                      <div class="text-title text-center" style="font-family: Kanit;">ยอดเล่น</div>
                      <div class="row no-gutters">
                        <div class="col-6">
                          <div class="card-report text-center">
                            <p class="mb-1" style="font-family: Kanit;">ฝาก</p>
                            <p class="mb-0">{{ numberWithCommas(this.cashback.deposit )}}</p>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="card-report text-center">
                            <p class="mb-1" style="font-family: Kanit;">ถอน</p>
                            <p class="mb-0">{{ numberWithCommas(this.cashback.withdraw )}}</p>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="card-report text-center">
                            <p class="mb-1" style="font-family: Kanit;">รายได้ทั้งหมด</p>
                            <p class="mb-0">{{ numberWithCommas(this.cashback.total )}}</p>
                          </div>
                        </div>
                        <div class="col-12 text-center" style="padding-top:22px;">
                          <a href="javascript:void(0)" @click="moveCashbackToWallet()" class="text-white js-account-approve-aware btn" :style="checkStyle()" data-toggle="modal">
                            <div style="font-size: 14px;font-family: Kanit,Helvetica Neue,Helvetica,Arial,sans-serif;">โอนเงินเข้ากระเป๋าหลัก</div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 col-lg-12 col-12 recommend_section">
                      <div v-html="nl2br(detail)" style="text-align: center;padding:30px;font-size: 16px;font-family: Kanit;"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import moment from 'moment-timezone'
import router from './../router'
const axios = require('axios').default
export default {
  name: 'Cashback',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    LeftSidebar: () => import('@/components/LeftSidebar.vue'),
    MobileLeftSidebar: () => import('@/components/MobileLeftSidebar.vue'),
    MainMenuBar: () => import('@/components/MainMenuBar.vue'),
    MobileMainMenu: () => import('@/components/MobileMainMenu.vue'),
    RunningText: () => import('@/components/RunningText.vue')
  },
  data: function () {
    return {
      cashback: [],
      detail: '',
      mainMenu: 'cashback',
      hoveredLeftIndex: null,
      hoveredMainIndex: null,
      leftMenuItems: [
        { name: 'เล่นบ่อย', path: '/main?type=favorite', icon: require('@/assets/images/menu_left/left_1.png'), hoverIcon: require('@/assets/images/menu_left/left_1_hover.png') },
        { name: 'ยอดนิยม', path: '/main?type=popular', icon: require('@/assets/images/menu_left/left_2.png'), hoverIcon: require('@/assets/images/menu_left/left_2_hover.png') },
        { name: 'คาสิโน', path: '/main?type=casino', icon: require('@/assets/images/menu_left/left_3.png'), hoverIcon: require('@/assets/images/menu_left/left_3_hover.png') },
        { name: 'สล็อต', path: '/main?type=slot', icon: require('@/assets/images/menu_left/left_4.png'), hoverIcon: require('@/assets/images/menu_left/left_4_hover.png') },
        { name: 'ยิงปลา', path: '/main?type=fishing', icon: require('@/assets/images/menu_left/left_5.png'), hoverIcon: require('@/assets/images/menu_left/left_5_hover.png') },
        { name: 'กีฬา', path: '/playsport', icon: require('@/assets/images/menu_left/left_6.png'), hoverIcon: require('@/assets/images/menu_left/left_6_hover.png') },
        { name: 'esport', path: '/playesport', icon: require('@/assets/images/menu_left/left_7.png'), hoverIcon: require('@/assets/images/menu_left/left_7_hover.png') },
        { name: 'hilo', path: '/playlotto', icon: require('@/assets/images/menu_left/left_9.png'), hoverIcon: require('@/assets/images/menu_left/left_9_hover.png') }
      ],
      mainMenuItems: [
        { name: 'โปรโมชั่น', path: '/promotion', icon: require('@/assets/images/menu_main/main_menu_1.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_1.png') },
        { name: 'แลกของรางวัล', path: '/rewards', icon: require('@/assets/images/menu_main/main_menu_2.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_2.png') },
        { name: 'คืนยอดเล่น', path: '/cashback', icon: require('@/assets/images/menu_main/main_menu_3.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_3.png') },
        { name: 'สิทธิพิเศษ', path: '/event', icon: require('@/assets/images/menu_main/main_menu_4.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_4.png') },
        { name: 'พันธมิตร', path: '/partner', icon: require('@/assets/images/menu_main/main_menu_5.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_5.png') },
        // { name: 'ฝากต่อเนื่อง', path: '/continue', icon: require('@/assets/images/menu_main/main_menu_6.png'), hoverIcon: require('@/assets/images/menu_main/main_menu_hover_6.png') }
      ]
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    }
  },
  methods: {
    // Menu hover methods
    onLeftMenuEnter (index) {
      this.hoveredLeftIndex = index
    },
    onLeftMenuLeave () {
      this.hoveredLeftIndex = null
    },
    onMainMenuEnter (index) {
      this.hoveredMainIndex = index
    },
    onMainMenuLeave () {
      this.hoveredMainIndex = null
    },
    nl2br (str, is_xhtml) {
      if (typeof str === 'undefined' || str === null) {
        return ''
      }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>'
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
    },
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    moveCashbackToWallet () {
      if (this.cashback.total && this.cashback.key) {
        this.$store.commit('user/SET_LOADING', true)
        this.$store.dispatch('user/moveCreditToWallet').finally((res) => {
          if (this.user.credit <= 5) {
            axios.get(`https://phenix.apifast.xyz/qcashback/cashback/${this.cashback.key}`)
            setTimeout(() => {
              this.getCashBack()
              this.$store.commit('user/SET_LOADING', false)
            }, 2000)
          } else {
            this.$swal({ icon: 'error', title: 'เงื่อนไข', text: 'ต้องมีเครดิตต่ำกว่า 5 บาท ถึงรับได้ค่ะ' })
            this.$store.commit('user/SET_LOADING', false)
          }
        }).catch(err => { console.error(err) })

        // axios.get(`https://phenix.apifast.xyz/qcashback/cashback/${this.cashback.key}`)
        // setTimeout(() => {
        //   this.getCashBack()
        //   this.$store.commit('user/SET_LOADING', false)
        // }, 2000)
      }
    },
    checkStyle () {
      if (this.cashback && this.cashback.total > 0) {
        return 'background: linear-gradient(180deg,#fbc844,#f88012);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      } else {
        return 'background: linear-gradient(180deg,#cccccc,#cccccc);height: 43px;min-width:120px;padding-left: 24px;padding-right: 24px;padding-top: 0.8em;'
      }
    },
    numberWithCommas (x) {
	  if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/')
      }
    },
    async getCashBack () {
      this.detail = (await firebase.database().ref(`/cashback/detail`).once('value')).val();
      const user = this.getUserId()
      if (user) {
        firebase.firestore().collection('cashback').where('date', '==', moment().tz('Asia/Bangkok').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) this.cashback = []
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.cashback = data
          })
        })
      }
    }
  },
  mounted () {
    this.scrollToTop()
    this.getCashBack()
  }
}
</script>
<style scoped>

/* Desktop Layout */
.desktop-layout {
  display: flex;
  min-height: 100vh;
}

.main-content {
  margin-left: 100px;
  padding-top: 105px;
  width: calc(100% - 100px);
  min-height: 100vh;
  background-image: url('../assets/images/background/desktop.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* Ensure x-cover appears above menu */
.main-content .x-cover {
  position: relative;
  z-index: 0;
}

.content-wrapper {
  padding: 20px;
}

/* Mobile Layout */
.mobile-layout {
  display: none;
  padding-top: 105px;
  min-height: 100vh;
  background-image: url('../assets/images/background/mobile.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* Mobile cover section positioning */
.mobile-layout .mobile-cover {
  margin-top: -105px;
  padding-top: 105px;
}

.mobile-with-sidebar {
  display: flex;
  min-height: calc(100vh - 300px);
}

.mobile-content-wrapper {
  padding: 10px;
}

/* Mobile x-cover positioning */
.mobile-cover {
  position: relative;
  width: 100%;
  height: auto;
  max-height: 200px;
  overflow: hidden;
}

.mobile-cover .-bg {
  width: 100%;
  height: auto;
  object-fit: cover;
  max-height: 200px;
}

.mobile-cover .-bg.-mobile {
  display: block;
}

.mobile-cover .-bg:not(.-mobile) {
  display: none;
}

.mobile-cover .container-fluid {
  padding: 10px;
}

.mobile-cover .-title {
  font-size: 18px !important;
  line-height: 1.3;
  margin-bottom: 5px;
}

.mobile-cover .-sub-title {
  font-size: 14px !important;
  line-height: 1.2;
}

/* Responsive Utilities */
.desktop-only {
  display: block;
}

.mobile-only {
  display: none;
}

@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }

  .mobile-only {
    display: block;
  }

  .desktop-layout {
    display: none;
  }

  .mobile-layout {
    display: block;
  }
}

@media (max-width: 768px) {
  .mobile-main-menu-item {
    min-width: 40px;
    padding: 6px;
  }
}

/* Existing Cashback Styles */
.text-title {
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  margin: 20px 0;
}

.card-report {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  padding: 20px;
  margin: 10px;
  color: #fff;
  backdrop-filter: blur(10px);
}

.card-report p {
  font-family: 'Kanit', sans-serif;
  margin: 0;
}

/* Mobile responsive adjustments */
@media screen and (max-width: 992px) {
    .resize {
        width: 899px;
    }
}

@media screen and (max-width: 600px) {
    .resize {
        width: 399px;
    }

    .mobile-cover {
        max-height: 250px;
    }

    .mobile-cover .-bg {
        max-height: 150px;
    }

    .mobile-cover .-title {
        font-size: 16px !important;
    }

    .mobile-cover .-sub-title {
        font-size: 12px !important;
    }
}

.bg-mobile2 {
  margin-right: 100px;
}

@media screen and (max-width: 992px) {
    .resize {
        width: 899px;
    }
}

@media screen and (max-width: 600px) {
    .resize {
        width: 399px;
    }
    .bg-mobile {
      background-color: #1c1c1c;
    }
    .bg-mobile2 {
      margin-right: 0;
    }
}
</style>
